// extracted by mini-css-extract-plugin
module.exports = {"paper":"ConfirmDialogPopup_paper__37hub","title":"ConfirmDialogPopup_title__3lYbq","content":"ConfirmDialogPopup_content__3zaAf"};